export * from './tab6.component'